<template lang="pug">
  .preloader
    .preloader__content
      .preloader__image
        .preloader__image-loaded-wr
          .preloader__image-loaded
      .preloader__line-wr
        .preloader__line
      .preloader__text
</template>

<script>
  import '@/components/common/preloader/preloader.styl';
  import {CommonHelpersVue} from '@/mixins/CommonHelpersVue';

  import EventBus from '@/eventBus';

  export default {
    name: 'Preloader',

    mixins: [CommonHelpersVue],

    components: {},

    data() {
      return {}
    },

    created() {
      EventBus.$on('pagePreloaderShow', () => {
        this.$nextTick(() => {
          this.disableScroll();
          $('.preloader').removeClass('preloader--hide');

          setTimeout(() => {
            $('.preloader').addClass('preloader--start');
            this.animateValue($('.preloader__text'), 0, 50, 500);
          }, 500);
        });
      });

      EventBus.$on('pagePreloaderHide', () => {
        this.$nextTick(() => {
          setTimeout(() => {
            $('.preloader').addClass('preloader--end');
            this.animateValue($('.preloader__text'), 50, 100, 500);

            setTimeout(() => {
              this.enableScroll();
              $('.preloader').addClass('preloader--hide');

              setTimeout(() => {
                $('.preloader').removeClass('preloader--start preloader--end');
                $('.preloader__text').html('0%');
              }, 500);
            }, 750);
          }, 750);
        });
      });
    },

    methods: {
      animateValue(obj, start, end, duration) {
        if(start === end) return;
        let range = end - start;
        let current = start;
        let increment = end > start ? 1 : -1;
        let stepTime = Math.abs(Math.floor(duration / range));
        let timer = setInterval(function() {
          current += increment;
          obj.html(current + '%');
          if(current == end) {
            clearInterval(timer);
          }
        }, stepTime);
      }
    }
  }
</script>
